import { Pipe, PipeTransform } from '@angular/core';
import { SalesByMenuCategoryResponse } from '../../models';

/**
 * Pipe to sort real time info menu total sales by categories
 * based on the specified column and direction.
 */
@Pipe({
  name: 'categorySort'
})
export class CategorySortPipe implements PipeTransform {
  transform(
    categoryKeys: string[] | null,
    sortColumn: 'name' | 'quantity' | 'total',
    sortDirection: 'asc' | 'desc',
    salesData?: SalesByMenuCategoryResponse
  ): string[] {
    if (!categoryKeys) {
      return [];
    }

    return [...categoryKeys].sort((a, b) => {
      let comparison = 0;

      if (sortColumn === 'name') {
        const nameA = a.toLowerCase();
        const nameB = b.toLowerCase();
        comparison = nameA.localeCompare(nameB);
      } else if (sortColumn === 'quantity' && salesData) {
        const qtyA = this.calculateTotalQuantity(salesData[a]) || 0;
        const qtyB = this.calculateTotalQuantity(salesData[b]) || 0;
        comparison = qtyA - qtyB;
      } else if (sortColumn === 'total' && salesData) {
        const totalA = this.calculateTotalSales(salesData[a]) || 0;
        const totalB = this.calculateTotalSales(salesData[b]) || 0;
        comparison = totalA - totalB;
      }

      return sortDirection === 'asc' ? comparison : -comparison;
    });
  }

  private calculateTotalQuantity(categoryItems: any[]): number {
    if (!categoryItems || !Array.isArray(categoryItems)) {
      return 0;
    }
    return categoryItems.reduce(
      (total, item) => total + (parseInt(item.total_quantity as any, 10) || 0),
      0
    );
  }

  private calculateTotalSales(categoryItems: any[]): number {
    if (!categoryItems || !Array.isArray(categoryItems)) {
      return 0;
    }
    return categoryItems.reduce(
      (total, item) => total + (parseFloat(item.total_sales as any) || 0),
      0
    );
  }
}
